
    import './styles.scoped.css';
    export default {
  "sticky-scrollbar": "awsui_sticky-scrollbar_faqt8_1mme3_177",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_faqt8_1mme3_186",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_faqt8_1mme3_189",
  "sticky-scrollbar-native-invisible": "awsui_sticky-scrollbar-native-invisible_faqt8_1mme3_192",
  "sticky-scrollbar-offset": "awsui_sticky-scrollbar-offset_faqt8_1mme3_195",
  "is-visual-refresh": "awsui_is-visual-refresh_faqt8_1mme3_198"
};
  